<template>
  <div :class="['asc-grid-cell-tooltip', { hide: !getTooltipContent }]">
    <span class="asc-grid-value">{{ getTooltipContent }}</span>
  </div>
</template>

<script>
export default {
  name: 'AscGridTooltip',

  props: {
    params: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    getTooltipContent() {
      return this.params.value.toString().replace(/&amp;/g, '&')
    },
  },

  beforeMount() {
    const data = this.params.api.getDisplayedRowAtIndex(
      this.params.rowIndex,
    ).data
    this.setState(data)
  },

  mounted() {
    if (this.params.width) {
      const width =
        this.params.width === 'columnWidth'
          ? this.params.column.actualWidth
          : this.params.width
      this.$el.style.width = `${width}px`
    }
  },

  methods: {
    setState(obj) {
      const that = this

      Object.keys(obj).forEach(function (key) {
        that[key] = obj[key]
      })
    },
  },
}
</script>

<style lang="scss">
.asc-grid-cell-tooltip {
  position: absolute;
  border-radius: 2px;
  background-color: $primary-white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
  overflow: hidden;
  pointer-events: none;
  transition: opacity 100ms;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 18px;
  z-index: 1;
  padding: 9px;
}

.asc-grid-cell-tooltip.ag-tooltip-hiding {
  opacity: 0;
}

.ag-cell {
  &.ag-cell-hasEllipsis {
    cursor: pointer;
    position: relative;

    &:hover {
      background-color: $accent-0;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      right: 0;
      border-color: transparent;
      border-style: solid;
      border-width: 5px;
    }
  }
}
</style>
